var $8e574de10f67cfc8$exports = {};
// Author: Michael Wehar
// Additional credits: Itay Livni, Michael Blättler
// MIT License
// Math functions
function $8e574de10f67cfc8$var$distance(x1, y1, x2, y2) {
    return Math.abs(x1 - x2) + Math.abs(y1 - y2);
}
function $8e574de10f67cfc8$var$weightedAverage(weights, values) {
    var temp = 0;
    for(let k = 0; k < weights.length; k++)temp += weights[k] * values[k];
    if (temp < 0 || temp > 1) console.log("Error: " + values);
    return temp;
}
// Component scores
// 1. Number of connections
function $8e574de10f67cfc8$var$computeScore1(connections, word) {
    return connections / (word.length / 2);
}
// 2. Distance from center
function $8e574de10f67cfc8$var$computeScore2(rows, cols, i, j) {
    return 1 - $8e574de10f67cfc8$var$distance(rows / 2, cols / 2, i, j) / (rows / 2 + cols / 2);
}
// 3. Vertical versus horizontal orientation
function $8e574de10f67cfc8$var$computeScore3(a, b, verticalCount, totalCount) {
    if (verticalCount > totalCount / 2) return a;
    else if (verticalCount < totalCount / 2) return b;
    else return 0.5;
}
// 4. Word length
function $8e574de10f67cfc8$var$computeScore4(val, word) {
    return word.length / val;
}
// Word functions
function $8e574de10f67cfc8$var$addWord(best, words, table) {
    var bestScore = best[0];
    var word = best[1];
    var index = best[2];
    var bestI = best[3];
    var bestJ = best[4];
    var bestO = best[5];
    words[index].startx = bestJ + 1;
    words[index].starty = bestI + 1;
    if (bestO == 0) {
        for(let k = 0; k < word.length; k++)table[bestI][bestJ + k] = word.charAt(k);
        words[index].orientation = "across";
    } else {
        for(let k = 0; k < word.length; k++)table[bestI + k][bestJ] = word.charAt(k);
        words[index].orientation = "down";
    }
    console.log(word + ", " + bestScore);
}
function $8e574de10f67cfc8$var$assignPositions(words) {
    var positions = {};
    for(let index in words){
        var word = words[index];
        if (word.orientation != "none") {
            var tempStr = word.starty + "," + word.startx;
            if (tempStr in positions) word.position = positions[tempStr];
            else {
                // Object.keys is supported in ES5-compatible environments
                positions[tempStr] = Object.keys(positions).length + 1;
                word.position = positions[tempStr];
            }
        }
    }
}
function $8e574de10f67cfc8$var$computeDimension(words, factor) {
    var temp = 0;
    for(let i = 0; i < words.length; i++)if (temp < words[i].answer.length) temp = words[i].answer.length;
    return temp * factor;
}
// Table functions
function $8e574de10f67cfc8$var$initTable(rows, cols) {
    var table = [];
    for(let i = 0; i < rows; i++){
        for(let j = 0; j < cols; j++)if (j == 0) table[i] = [
            "-"
        ];
        else table[i][j] = "-";
    }
    return table;
}
function $8e574de10f67cfc8$var$isConflict(table, isVertical, character, i, j) {
    if (character != table[i][j] && table[i][j] != "-") return true;
    else if (table[i][j] == "-" && !isVertical && i + 1 in table && table[i + 1][j] != "-") return true;
    else if (table[i][j] == "-" && !isVertical && i - 1 in table && table[i - 1][j] != "-") return true;
    else if (table[i][j] == "-" && isVertical && j + 1 in table[i] && table[i][j + 1] != "-") return true;
    else if (table[i][j] == "-" && isVertical && j - 1 in table[i] && table[i][j - 1] != "-") return true;
    else return false;
}
function $8e574de10f67cfc8$var$attemptToInsert(rows, cols, table, weights, verticalCount, totalCount, word, index) {
    var bestI = 0;
    var bestJ = 0;
    var bestO = 0;
    var bestScore = -1;
    // Horizontal
    for(let i = 0; i < rows; i++)for(let j = 0; j < cols - word.length + 1; j++){
        var isValid = true;
        var atleastOne = false;
        var connections = 0;
        var prevFlag = false;
        for(let k = 0; k < word.length; k++){
            if ($8e574de10f67cfc8$var$isConflict(table, false, word.charAt(k), i, j + k)) {
                isValid = false;
                break;
            } else if (table[i][j + k] == "-") {
                prevFlag = false;
                atleastOne = true;
            } else if (prevFlag) {
                isValid = false;
                break;
            } else {
                prevFlag = true;
                connections += 1;
            }
        }
        if (j - 1 in table[i] && table[i][j - 1] != "-") isValid = false;
        else if (j + word.length in table[i] && table[i][j + word.length] != "-") isValid = false;
        if (isValid && atleastOne && word.length > 1) {
            var tempScore1 = $8e574de10f67cfc8$var$computeScore1(connections, word);
            var tempScore2 = $8e574de10f67cfc8$var$computeScore2(rows, cols, i, j + word.length / 2, word);
            var tempScore3 = $8e574de10f67cfc8$var$computeScore3(1, 0, verticalCount, totalCount);
            var tempScore4 = $8e574de10f67cfc8$var$computeScore4(rows, word);
            var tempScore = $8e574de10f67cfc8$var$weightedAverage(weights, [
                tempScore1,
                tempScore2,
                tempScore3,
                tempScore4
            ]);
            if (tempScore > bestScore) {
                bestScore = tempScore;
                bestI = i;
                bestJ = j;
                bestO = 0;
            }
        }
    }
    // Vertical
    for(let i = 0; i < rows - word.length + 1; i++)for(let j = 0; j < cols; j++){
        var isValid = true;
        var atleastOne = false;
        var connections = 0;
        var prevFlag = false;
        for(let k = 0; k < word.length; k++){
            if ($8e574de10f67cfc8$var$isConflict(table, true, word.charAt(k), i + k, j)) {
                isValid = false;
                break;
            } else if (table[i + k][j] == "-") {
                prevFlag = false;
                atleastOne = true;
            } else if (prevFlag) {
                isValid = false;
                break;
            } else {
                prevFlag = true;
                connections += 1;
            }
        }
        if (i - 1 in table && table[i - 1][j] != "-") isValid = false;
        else if (i + word.length in table && table[i + word.length][j] != "-") isValid = false;
        if (isValid && atleastOne && word.length > 1) {
            var tempScore1 = $8e574de10f67cfc8$var$computeScore1(connections, word);
            var tempScore2 = $8e574de10f67cfc8$var$computeScore2(rows, cols, i + word.length / 2, j, word);
            var tempScore3 = $8e574de10f67cfc8$var$computeScore3(0, 1, verticalCount, totalCount);
            var tempScore4 = $8e574de10f67cfc8$var$computeScore4(rows, word);
            var tempScore = $8e574de10f67cfc8$var$weightedAverage(weights, [
                tempScore1,
                tempScore2,
                tempScore3,
                tempScore4
            ]);
            if (tempScore > bestScore) {
                bestScore = tempScore;
                bestI = i;
                bestJ = j;
                bestO = 1;
            }
        }
    }
    if (bestScore > -1) return [
        bestScore,
        word,
        index,
        bestI,
        bestJ,
        bestO
    ];
    else return [
        -1
    ];
}
function $8e574de10f67cfc8$var$generateTable(table, rows, cols, words, weights) {
    var verticalCount = 0;
    var totalCount = 0;
    for(let outerIndex in words){
        var best = [
            -1
        ];
        for(let innerIndex in words)if ("answer" in words[innerIndex] && !("startx" in words[innerIndex])) {
            var temp = $8e574de10f67cfc8$var$attemptToInsert(rows, cols, table, weights, verticalCount, totalCount, words[innerIndex].answer, innerIndex);
            if (temp[0] > best[0]) best = temp;
        }
        if (best[0] == -1) break;
        else {
            $8e574de10f67cfc8$var$addWord(best, words, table);
            if (best[5] == 1) verticalCount += 1;
            totalCount += 1;
        }
    }
    for(let index in words)if (!("startx" in words[index])) words[index].orientation = "none";
    return {
        "table": table,
        "result": words
    };
}
function $8e574de10f67cfc8$var$removeIsolatedWords(data) {
    var oldTable = data.table;
    var words = data.result;
    var rows = oldTable.length;
    var cols = oldTable[0].length;
    var newTable = $8e574de10f67cfc8$var$initTable(rows, cols);
    // Draw intersections as "X"'s
    for(let wordIndex in words){
        var word = words[wordIndex];
        if (word.orientation == "across") {
            var i = word.starty - 1;
            var j = word.startx - 1;
            for(let k = 0; k < word.answer.length; k++){
                if (newTable[i][j + k] == "-") newTable[i][j + k] = "O";
                else if (newTable[i][j + k] == "O") newTable[i][j + k] = "X";
            }
        } else if (word.orientation == "down") {
            var i = word.starty - 1;
            var j = word.startx - 1;
            for(let k = 0; k < word.answer.length; k++){
                if (newTable[i + k][j] == "-") newTable[i + k][j] = "O";
                else if (newTable[i + k][j] == "O") newTable[i + k][j] = "X";
            }
        }
    }
    // Set orientations to "none" if they have no intersections
    for(let wordIndex in words){
        var word = words[wordIndex];
        var isIsolated = true;
        if (word.orientation == "across") {
            var i = word.starty - 1;
            var j = word.startx - 1;
            for(let k = 0; k < word.answer.length; k++)if (newTable[i][j + k] == "X") {
                isIsolated = false;
                break;
            }
        } else if (word.orientation == "down") {
            var i = word.starty - 1;
            var j = word.startx - 1;
            for(let k = 0; k < word.answer.length; k++)if (newTable[i + k][j] == "X") {
                isIsolated = false;
                break;
            }
        }
        if (word.orientation != "none" && isIsolated) {
            delete words[wordIndex].startx;
            delete words[wordIndex].starty;
            delete words[wordIndex].position;
            words[wordIndex].orientation = "none";
        }
    }
    // Draw new table
    newTable = $8e574de10f67cfc8$var$initTable(rows, cols);
    for(let wordIndex in words){
        var word = words[wordIndex];
        if (word.orientation == "across") {
            var i = word.starty - 1;
            var j = word.startx - 1;
            for(let k = 0; k < word.answer.length; k++)newTable[i][j + k] = word.answer.charAt(k);
        } else if (word.orientation == "down") {
            var i = word.starty - 1;
            var j = word.startx - 1;
            for(let k = 0; k < word.answer.length; k++)newTable[i + k][j] = word.answer.charAt(k);
        }
    }
    return {
        "table": newTable,
        "result": words
    };
}
function $8e574de10f67cfc8$var$trimTable(data) {
    var table = data.table;
    var rows = table.length;
    var cols = table[0].length;
    var leftMost = cols;
    var topMost = rows;
    var rightMost = -1;
    var bottomMost = -1;
    for(let i = 0; i < rows; i++){
        for(let j = 0; j < cols; j++)if (table[i][j] != "-") {
            var x = j;
            var y = i;
            if (x < leftMost) leftMost = x;
            if (x > rightMost) rightMost = x;
            if (y < topMost) topMost = y;
            if (y > bottomMost) bottomMost = y;
        }
    }
    var trimmedTable = $8e574de10f67cfc8$var$initTable(bottomMost - topMost + 1, rightMost - leftMost + 1);
    for(let i = topMost; i < bottomMost + 1; i++)for(let j = leftMost; j < rightMost + 1; j++)trimmedTable[i - topMost][j - leftMost] = table[i][j];
    var words = data.result;
    for(let entry in words)if ("startx" in words[entry]) {
        words[entry].startx -= leftMost;
        words[entry].starty -= topMost;
    }
    return {
        "table": trimmedTable,
        "result": words,
        "rows": Math.max(bottomMost - topMost + 1, 0),
        "cols": Math.max(rightMost - leftMost + 1, 0)
    };
}
function $8e574de10f67cfc8$var$tableToString(table, delim) {
    var rows = table.length;
    if (rows >= 1) {
        var cols = table[0].length;
        var output = "";
        for(let i = 0; i < rows; i++){
            for(let j = 0; j < cols; j++)output += table[i][j];
            output += delim;
        }
        return output;
    } else return "";
}
function $8e574de10f67cfc8$var$generateSimpleTable(words) {
    var rows = $8e574de10f67cfc8$var$computeDimension(words, 3);
    var cols = rows;
    var blankTable = $8e574de10f67cfc8$var$initTable(rows, cols);
    var table = $8e574de10f67cfc8$var$generateTable(blankTable, rows, cols, words, [
        0.7,
        0.15,
        0.1,
        0.05
    ]);
    var newTable = $8e574de10f67cfc8$var$removeIsolatedWords(table);
    var finalTable = $8e574de10f67cfc8$var$trimTable(newTable);
    $8e574de10f67cfc8$var$assignPositions(finalTable.result);
    return finalTable;
}
function $8e574de10f67cfc8$var$generateLayout(words_json) {
    var layout = $8e574de10f67cfc8$var$generateSimpleTable(words_json);
    layout.table_string = $8e574de10f67cfc8$var$tableToString(layout.table, "<br>");
    return layout;
}
$8e574de10f67cfc8$exports = {
    generateLayout: $8e574de10f67cfc8$var$generateLayout
};


const $c1ce9d969bfa6909$var$createSVG = (target, layout)=>{
    console.log('SVG', target, layout);
    const createContent = (withClues = false)=>{
        const svg = document.createElement('svg');
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.setAttribute('viewbox', `-0.5 -0.5 ${width} ${height}`);
        svg.setAttribute('width', width);
        svg.setAttribute('height', height);
        const style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.innerHTML = `
    g rect {
        fill:#ffffff;
        stroke-width:1.0;
        stroke:#000001;
        fill-opacity:1;
    }

    .cx-a {
        font-size:14.0px;
        font-family:monospace;
        text-anchor:middle;
        pointer-events:none;
        fill:#000003;
    }
    
    .cx-b, .cx-c {
        font-size:8.0px;
        font-family:monospace;
        pointer-events:none;
        font-weight:bold;
        fill:#000002;
    }
    
    .cx-b {
        text-anchor:end;
    }
    
    .cx-c {
        text-anchor:start;
    }
    `;
        svg.appendChild(style);
        let x = 0;
        let y = 0;
        for (const row of layout.table){
            x = 0;
            for (const cell of row){
                if (cell === '-') {
                    x++;
                    continue;
                }
                let gx = x * 30;
                let gy = y * 30;
                const g = document.createElement('g');
                const field = document.createElement('rect');
                field.setAttribute('x', gx);
                field.setAttribute('y', gy);
                field.setAttribute('width', '30');
                field.setAttribute('height', '30');
                const content = document.createElement('text');
                content.classList.add('cx-a');
                content.setAttribute('dy', '.28em');
                content.setAttribute('x', gx + 15);
                content.setAttribute('y', gy + 15);
                content.innerText = cell;
                const numbers = [];
                const words = layout.result.filter((r)=>r.startx === x + 1 && r.starty === y + 1);
                for (const w of words){
                    const number = document.createElement('text');
                    number.classList.add(w.orientation === 'across' ? 'cx-b' : 'cx-c');
                    number.setAttribute('dy', '1em');
                    number.setAttribute('x', gx + (w.orientation === 'across' ? 28 : 2));
                    number.setAttribute('y', gy + (w.orientation === 'across' ? 2 : 18));
                    number.innerText = allWords.findIndex((w2)=>w2 === w.answer) + 1;
                    numbers.push(number);
                }
                g.appendChild(field);
                if (withClues) g.appendChild(content);
                for (const number of numbers)g.appendChild(number);
                svg.appendChild(g);
                x++;
            }
            y++;
        }
        return svg.outerHTML;
    };
    const allWords = layout.result.map((r)=>r.answer);
    const allQuestions = layout.result.map((r)=>r.clue);
    const width = layout.cols * 30 + 2;
    const height = layout.rows * 30 + 2;
    target.innerHTML = createContent(false);
    document.getElementById('svg2').innerHTML = createContent(true);
    const wordlist = document.createElement('table');
    let i = 1;
    for (const word of allQuestions){
        const tr = document.createElement('tr');
        const l = document.createElement('th');
        const r = document.createElement('td');
        l.innerText = i;
        r.innerText = word;
        tr.appendChild(l);
        tr.appendChild(r);
        wordlist.appendChild(tr);
        i++;
    }
    document.getElementById('wordlist').appendChild(wordlist);
};
window.addEventListener('load', ()=>{
    const form = document.querySelector('form');
    const result = document.querySelector('#crossword');
    const svgContainer = document.querySelector('#svg');
    /*
    const saved = localStorage.getItem('table')
    if (saved) {
        result.innerHTML = saved
    }
    */ const savedLayout = localStorage.getItem('layout');
    if (savedLayout) $c1ce9d969bfa6909$var$createSVG(svgContainer, JSON.parse(savedLayout));
    form.addEventListener('submit', (e)=>{
        e.preventDefault();
        document.getElementById('wordlist').innerHTML = '';
        svgContainer.innerHTML = '';
        (()=>{
            const textarea = form.querySelector('textarea');
            const input = textarea.value.trim();
            const data = input.split("\n").reduce((res, line)=>{
                let word = '';
                while(true){
                    word += line.substr(0, 1);
                    line = line.substr(1);
                    if (word.trim().length < word.length) break;
                    if (line.length === 0) break;
                }
                res.push({
                    answer: word.trim(),
                    clue: line.trim()
                });
                return res;
            }, []);
            const layout = $8e574de10f67cfc8$exports.generateLayout(data);
            localStorage.setItem('layout', JSON.stringify(layout));
            $c1ce9d969bfa6909$var$createSVG(svgContainer, layout);
        /*
                const allWords = layout.result.map(r => r.answer)
                console.log('all', layout)

                const t = document.createElement('table')
                let x = 0, y = 0
                for (const row of layout.table) {
                        y++
                        x = 0
                        const r = document.createElement('tr')
                        for (const cell of row) {
                                x++
                                const c = document.createElement('td')
                                c.setAttribute('style', `width: calc((100% / ${layout.table[0].length}) + 2px)`)
                                if (cell !== '-') {
                                    c.classList.add('has-letter')

                                    c.setAttribute('data-letter', cell)

                                    const words = layout.result.filter(r => r.startx === x && r.starty === y)
                                    for (const w of words) {
                                        const span = document.createElement('span')
                                        span.classList.add(w.orientation)
                                        span.innerText = allWords.findIndex(w2 => w2 === w.answer)
                                        c.appendChild(span)
                                    }
                                }
                                r.appendChild(c)
                        }
                        t.appendChild(r)
                }

                result.appendChild(t)
                localStorage.setItem('table', result.innerHTML)
                */ })();
    });
}) /*
const input_json = [{"clue":"that which is established as a rule or model by authority, custom, or general consent","answer":"standard"},{"clue":"a machine that computes","answer":"computer"},{"clue":"the collective designation of items for a particular purpose","answer":"equipment"},{"clue":"an opening or entrance to an inclosed place","answer":"port"},{"clue":"a point where two things can connect and interact","answer":"interface"}]

console.log(clg)
*/ ;


//# sourceMappingURL=crossword.74328700.js.map
